import { getToken } from "../../../shared/utils/common";

export class CommandCreateLayer {
    async run(adId: number, formData: any) {
            const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/${adId}/layers/`
            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: { "Authorization": `Token ${getToken()} `},
                    body: formData,
                    })
                .then(response =>  response.json())
                .then(json => json)
                .catch(err => console.log(err));
                if(response) {
                    return response;
                }
            } catch (error) {
                console.error('Error fetching data:', error);
                throw error;
            }
        }

}
